import { useState } from "react";
import api from "../api";

export default function ResetPassword() {
  const params = new URLSearchParams(window.location.search);
  const email = params.get("email") || "";
  const token = params.get("token") || "";

  const [newPassword, setNewPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");

  const submit = async e => {
    e.preventDefault();
    setError("");
    if (newPassword !== confirm) {
      setError("Passwörter stimmen nicht überein.");
      return;
    }
    try {
      await api.post("/auth/reset-password", { email, token, newPassword });
      setDone(true);
    } catch (e) {
      setError(e?.response?.data?.error || "Fehler beim Zurücksetzen.");
    }
  };

  return (
  <div style={{width:'100vw',margin:0,padding:0}}>
      <h2>Passwort zurücksetzen</h2>
      {done ? (
        <div style={{color:'#2e7d32',marginTop:24}}>
          Das Passwort wurde erfolgreich geändert.<br/>
          Du kannst dich jetzt mit dem neuen Passwort anmelden.
        </div>
      ) : (
        <form onSubmit={submit} style={{display:'flex',flexDirection:'column',gap:16}}>
          <input type="password" placeholder="Neues Passwort" value={newPassword} onChange={e=>setNewPassword(e.target.value)} required style={{padding:'12px',fontSize:'1rem'}} />
          <input type="password" placeholder="Wiederholen" value={confirm} onChange={e=>setConfirm(e.target.value)} required style={{padding:'12px',fontSize:'1rem'}} />
          <button className="hero-btn-primary" type="submit">Passwort setzen</button>
          {error && <div style={{color:'#d32f2f'}}>{error}</div>}
        </form>
      )}
    </div>
  );
}
